import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseEntityService } from "./rest-common.service";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class PermissionService extends BaseEntityService {
  public resource_url = `${this.BASE_API_URL}/user/permissions/`;

  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  getPermissions() {
    return this.get(this.resource_url);
  }

  getConfig(creativeid, service) {
    return this.get(`${this.BASE_API_URL}/${service}/${creativeid}/config`);
  }

  getAccounts(client) {
    let url = this.buildUrl(`${this.BASE_API_URL}/${client.name}/${client.id}/account/`, '', client.params)
    return this.get(url);
  }

  setCreatePermissions(permissions) {
    localStorage.setItem('createPermissions', permissions);
  }

  getCreatePermissions(component) {
    let createPermissions = (localStorage.getItem('createPermissions') || '').split(',')
    // console.log('createPermissions >', createPermissions.filter(ele => ele == component), createPermissions.filter(ele => ele == component).length >= 1)
    return createPermissions.filter(ele => ele == component).length >= 1;
  }

  setEditPermissions(permissions) {
    localStorage.setItem('editPermissions', permissions);
  }

  getEditPermissions(component) {
    let editPermissions = (localStorage.getItem('editPermissions') || '').split(',')
    // console.log(editPermissions)
    // console.log('editPermissions >', editPermissions.filter(ele => ele == component), editPermissions.filter(ele => ele == component).length >= 1)
    return editPermissions.filter(ele => ele == component).length >= 1;
  }

  getComponentEntityPerm(component, permissionType, entity, isPlatFormEntity) {
    let client_prefix: string;
    let permission: string;

    if (isPlatFormEntity) {
      if (component.advertiserId) {
        client_prefix = "advertiser_";
      } else if (component.agencyId) {
        client_prefix = "agency_";
      } else if (component.agcAdvId) {
        client_prefix = "agadv_";
      } else {
        client_prefix = "platform_";
      }
    }

    permission = isPlatFormEntity ? client_prefix + entity : entity;

    switch (permissionType) {
      case "create":
        return this.getCreatePermissions(permission);
      case "edit":
        return this.getEditPermissions(permission);
      case "view":
          return this.getViewPermissions(permission);
      case "delete":
          return this.getDeletePermissions(permission);
      default:
        return false;
    }
  }

  setViewPermissions(permissions) {
    localStorage.setItem('viewPermissions', permissions);
  }

  getViewPermissions(component) {
    let viewPermissions = (localStorage.getItem('viewPermissions') || '').split(',')
    // console.log('viewPermissions >', viewPermissions.filter(ele => ele == component), viewPermissions.filter(ele => ele == component).length >= 1)
    return viewPermissions.filter(ele => ele == component).length >= 1;
  }

  setDeletePermissions(permissions) {
    localStorage.setItem('deletePermissions', permissions);
  }

  getDeletePermissions(component) {
    let deletePermissions = (localStorage.getItem('deletePermissions') || '').split(',')
    // console.log('deletePermissions >', deletePermissions.filter(ele => ele == component), deletePermissions.filter(ele => ele == component).length >= 1)
    return deletePermissions.filter(ele => ele == component).length >= 1;
  }

  setListPermissions(permissions) {
    localStorage.setItem('listPermissions', permissions);
  }

  getListPermissions(component) {
    let listPermissions = (localStorage.getItem('listPermissions') || '').split(',')
    // console.log('ListPermissions >', ListPermissions.filter(ele => ele == component), ListPermissions.filter(ele => ele == component).length >= 1)
    return listPermissions.filter(ele => ele == component).length >= 1;
  }

  setMiscellaneousPermission(permission_name, permission_values) {
    localStorage.setItem(permission_name, permission_values);
  }

  getMiscellaneousPermission(permission_name, component) {
    let miscellaneousPermission = (localStorage.getItem(permission_name) || '').split(',')
    return miscellaneousPermission.filter(ele => ele == component).length >= 1;
  }

  setClientPermission(permissions) {
    localStorage.setItem("clientPermissions", permissions);
  }
  getClientPermission(component) {
    let clinentPermissionList = (localStorage.getItem("clientPermissions") || '').split(',')
    return clinentPermissionList.filter(ele => ele == component).length >= 1;
  }
  // setClientStatePermission(component) {
  //   localStorage.setItem('clientStateData', JSON.stringify(component));
  // }
  // getClientStatePermission() {
  //   let clientStateData = localStorage.getItem('clientStateData')
  //   return JSON.parse(clientStateData)
  // }
}
